import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

import { QRCodeData } from 'src/app/model/qrcode-data';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
    selector: 'request-qrcode',
    templateUrl: './request-qrcode.component.html',
    styleUrls: ['./request-qrcode.component.scss'],
})
export class RequestQrcodeComponent implements OnInit, OnDestroy {
    public data: QRCodeData | null = null;

    constructor(private appService: AppService, private navigationService: NavigationService) {}

    ngOnInit(): void {
        this.navigationService.activity.toolbar.reset();
        this.navigationService.activity.toolbar.setTitle('Просмотр QR-кода');
        this.data = this.appService.qrCodeImage;
    }

    ngOnDestroy(): void {
        this.appService.qrCodeImage = null;
    }
}
